module.exports = __webpack_public_path__ + "img/rodapeAmarelo.97658f4b.png";